<template>
  <th :data-key="key2">
    <slot />
    <div
      v-if="showStatistic"
      class="title-statistic"
      :class="`${!['Left_Gap', 'Right_Gap'].includes(key2) ? 'has-border' : ''}`"
    >
      <template v-if="res.val === '-' && res.unit === '-'">
        <span
          key="value"
          class="value"
          >--</span
        >
      </template>
      <template v-else>
        <!-- 这里用一个 &nbsp; 撑高 -->
        <span
          v-if="res.valIsEmpty"
          key="empty-value"
          class="value"
          >&nbsp;</span
        >
        <span
          v-else
          key="value"
          class="value"
          >{{ res.val }}</span
        >
        <span
          key="unit"
          class="unit"
          >{{ res.unit }}</span
        >
      </template>
    </div>
  </th>
</template>

<script setup>
import { computed, reactive, watch } from 'vue';
import unitHelper from '@client/helper/unit';

const props = defineProps({
  showStatistic: {
    type: Boolean,
    default: false
  },
  key2: {
    type: String,
    default: ''
  },
  statisticInfo: {
    type: Array,
    default: () => ['', '']
  }
});

const res = computed(() => {
  const data = { val: '', unit: '' };
  if (props.showStatistic && props.statisticInfo) {
    const [value, unit] = props.statisticInfo;
    data.val = value;
    data.valIsEmpty = unitHelper.isNoValue(value);
    data.unit = unitHelper.isNoValue(unit) ? '' : unit;
  }
  return data;
});
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';
</style>
